import webClient from "../config/api.config";
import i18n from "../i18n";
import {
  BulkDoctorInvitationRequest,
  DoctorInvitationRequest,
} from "../types/doctorInvitation.definition";

export function inviteDoctor(data: DoctorInvitationRequest) {
  return webClient.request({
    method: "post",
    url: `doctors/invitations`,
    data,
    params: { lang: i18n.language || "fr" },
  });
}

export function inviteDoctorsBulk(data: BulkDoctorInvitationRequest) {
  return webClient.request({
    method: "post",
    url: `doctors/invitations/bulk`,
    data,
    params: { lang: i18n.language || "fr" },
  });
}

export function resendInvitation(id: number) {
  return webClient.request({
    method: "post",
    url: `doctors/invitations/${id}/resend`,
    params: { lang: i18n.language || "fr" },
  });
}

export function getAllInvitations() {
  return webClient.request({
    method: "get",
    url: `doctors/invitations`,
  });
}

export function cancelInvitation(id: number) {
  return webClient.request({
    method: "delete",
    url: `doctors/invitations/${id}`,
  });
}

export function getInvitationEvents(id: number) {
  return webClient.request({
    method: "get",
    url: `doctors/invitations/${id}/events`,
  });
}
